import React from 'react';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TeamSummary from '../../../components/TeamSummary';
import { ovenPlayerStyle, StyledCol, Wrapper } from './Tv.style';
import {
  selectCurrentRace,
  selectCurrentRaceIndex,
  selectIsStreaming,
  selectMatch,
  selectNextRace,
  selectPreviousRace,
} from '../../slice/selectors';
import Loader from '../../../components/Loader/Loader.style';
import MatchNotFound from '../../../components/MatchNotFound';
import { ROUTES } from '../../../routes/routes';
import { useMatchPolling } from '../../hooks/useMatchPolling';
import OvenPlayerStream from 'components/OvenPlayerStream';
import LeagueLogo from '../../../assets/logo/liga-wspinaczkowa-dark.svg';
import RacePlayers from 'components/RacePlayers';
import { remToPx } from 'utils/utils';
import { STREAM_BASE } from 'app/consts';
import { useLeagueWS } from 'app/hooks/useLeagueWS';

// temporary
const CROP_WALL_IDS = ['skywall1'];
const CROP_WALL_NAMES = ['makak'];

const Tv: React.FC = () => {
  const { leagueId = '', matchId = '', wallId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const wallName = searchParams.get('wallName');

  // temporary
  const crop =
    CROP_WALL_IDS.includes(wallId) ||
    CROP_WALL_NAMES.includes(wallName?.toLowerCase() || '');

  const match = useSelector(selectMatch);
  const currentRace = useSelector(selectCurrentRace);
  const nextRace = useSelector(selectNextRace);
  const previousRace = useSelector(selectPreviousRace);
  const currentRaceIndex = useSelector(selectCurrentRaceIndex);
  const isStreaming = useSelector(selectIsStreaming);

  const streamId = `${leagueId}_${matchId}_${wallId}`;
  const streamUrl = `${STREAM_BASE}${streamId}`;
  const qrCodeUrl = `${window.location.origin}${ROUTES.LIVE.replace(
    ':leagueId',
    leagueId,
  ).replace(':matchId', matchId)}`;

  const { loading, error, refetchMatch, refetchRuns } = useMatchPolling(
    leagueId,
    matchId,
  );
  const initialLoadError = error && !match;

  const requestFullscreen = () => {
    document.documentElement.requestFullscreen();
  };

  useLeagueWS({
    leagueId,
    matchId,
    match,
    refetchMatch,
    refetchRuns,
  });

  return (
    <Wrapper
      fluid
      className={`${initialLoadError ? '' : ''}`}
      onClick={requestFullscreen}
    >
      {initialLoadError && <MatchNotFound />}
      {!initialLoadError &&
        (loading ? (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <Loader />
          </div>
        ) : (
          <>
            <Row
              className="g-0 d-flex flex-fill justify-content-center"
              style={{ columnGap: '2rem' }}
            >
              {/* score */}
              <Col
                className="g-0 flex-grow-1 d-flex flex-column justify-content-center"
                style={{ rowGap: '3rem' }}
              >
                {/* logo */}
                <div
                  className="d-flex w-100 justify-content-center"
                  style={{ padding: '0 0 0 16.5rem' }}
                >
                  <img
                    src={LeagueLogo}
                    alt="League Logo"
                    width={remToPx(12)}
                    height={remToPx(10.25)}
                  />
                </div>

                <div className="d-flex flex-column" style={{ rowGap: '1rem' }}>
                  {/* Team summary */}
                  <div
                    className="d-flex g-0 align-items-center"
                    style={{ padding: '0 0 0 16.5rem' }}
                  >
                    <div className="d-flex flex-fill justify-content-center">
                      <TeamSummary
                        teams={match?.teams!}
                        theme="dark"
                        size={2}
                      />
                    </div>
                  </div>
                  {/* Prevous race */}
                  {previousRace && (
                    <RacePlayers
                      race={previousRace}
                      raceIndex={currentRaceIndex - 1}
                      previous
                      size={2}
                    />
                  )}
                  {/* Current race */}
                  {currentRace && (
                    <RacePlayers
                      race={currentRace}
                      raceIndex={currentRaceIndex}
                      current
                      size={2}
                    />
                  )}
                  {/* Next race */}
                  {nextRace && (
                    <RacePlayers
                      race={nextRace}
                      raceIndex={currentRaceIndex + 1}
                      next
                      size={2}
                    />
                  )}
                </div>
                <div
                  className="text-center text-light fs-1"
                  style={{ padding: '0 0 0 16.5rem' }}
                >
                  Wyniki na ligawspinaczkowa.pl
                </div>
              </Col>
              {/* Video */}
              <StyledCol
                xs="auto"
                className="d-flex flex-column justify-content-between"
                visibility={isStreaming ? 'visible' : 'hidden'}
              >
                <style>{ovenPlayerStyle}</style>
                <OvenPlayerStream
                  url={streamUrl}
                  waterMark={{
                    text: `<span class="live">Na żywo</span> <span class="wall-name">${
                      wallName || wallId
                    }</span>`,
                    font: {
                      'font-size': '1.5rem',
                      'font-family': 'Oswald, Arial, sans-serif',
                      color: '#fff',
                      'font-weight': 'normal',
                    },
                    opacity: 1,
                    position: 'bottom-right',
                    x: '0%',
                    y: '0%',
                    width: '100%',
                  }}
                  crop={crop}
                />
              </StyledCol>
            </Row>
          </>
        ))}
    </Wrapper>
  );
};

export default Tv;
